<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Consulta Inducciones</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Consulta Inducciones</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.idCompania" [disabled]="listaCompanias.length == 1" (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.sedes" name="sedes" multiple>
                <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Trabajador:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Nombres y Apellidos </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nombreEmpleado" name="nombreEmpleado"
                maxlength="40" />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Nro Documento Identidad:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nro Documento Identidad</mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nroDocumentoIdentidad" name="nroDocumentoIdentidad"
                maxlength="15" (keypress)="keyPressNumberOnly($event)" />
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Empresa </mat-label>
              <input matInput type="text" placeholder="Contratista" [(ngModel)]="modelFilter.nombreContratista"
                name="nombreContratista" maxlength="40" />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Fecha de Inducción:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Fecha de Inducción</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Desde" [(ngModel)]="modelFilter.fechaInicioInduccion" />
                <input matEndDate placeholder="Hasta" [(ngModel)]="modelFilter.fechaFinInduccion" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-2 control-label">Capacitador:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Capacitador </mat-label>
              <input matInput type="text" placeholder="Capacitador" [(ngModel)]="modelFilter.nombreCapacitador"
                name="nombreCapacitador" maxlength="40" />
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.estados" name="idEstado" multiple>
                <mat-option *ngFor="let item of listaEstadoInducciones; index as i" [value]="item.idParametroDetalle">{{
                  item.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <!-- <div class="col-sm-6 text-left">
              <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon> Exportar</a>
            </div> -->
          <div class="col-sm-12 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="modelListaPersonas" class="table table-striped table-vcenter">
          
        <ng-container matColumnDef="compania">
          <th mat-header-cell *matHeaderCellDef>Compañía</th>
          <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
        </ng-container>

          <ng-container matColumnDef="contratista">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.contratista }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombreSede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.nombreSede }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="solicitante">
              <th mat-header-cell *matHeaderCellDef>Solicitante</th>
              <td mat-cell *matCellDef="let element" class="centre">
                {{ element.solicitante }}
              </td>
            </ng-container> -->

          <ng-container matColumnDef="trabajador">
            <th mat-header-cell *matHeaderCellDef>Trabajador</th>
            <td mat-cell *matCellDef="let element">
              {{ element.persona.nombres }} {{ element.persona.apellidoPaterno }}
              {{ element.persona.apellidoMaterno }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro Documento Identidad</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.persona.nroDocumentoIdentidad }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_induccion">
            <th mat-header-cell *matHeaderCellDef>Fecha y hora de Inducción</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaHoraInduccion | date: "dd/MM/yyyy HH:mm" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="capacitador">
            <th mat-header-cell *matHeaderCellDef>Capacitador</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.nombresCapacitador }}
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- <pre>{{ modelListaInducciones | json }}</pre> -->